var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-container info-html-wrapper"},[_c('h1',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.$t('GETTING STARTED'))+"\n  ")]),_vm._v(" "),_c('html-loader',{attrs:{"url":_vm.contentUrl}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01314ecd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GettingStarted.vue
// module id = 1434
// module chunks = 0